import {defineStore} from "pinia";

export const useToastrStore = defineStore('toastr', {
    state: () => ({
        _message: null
    }),

    getters: {
        message: (state) => state._message
    },

    actions:  {
        show(message) {
            this._message = message
        },
        hide() {
            this._message = null
        }
    }
})
